<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,toRefs,watch } from 'vue'
import CustomList from "../../compositions/CustomList.vue";
import ModalDialog from "../../compositions/ModalDialog.vue";
import config from "../../config.js";
import { errorAlert } from "../../plugins/alert";
import { getFieldValue } from "../../plugins/utility";
import qs from 'qs';
import axios from '../../plugins/axios.ts';

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    type:{
      type:String,
      default:() => {
        return 'default';
      },
    },
    medicineId:{
      type:Number,
      default:() => {
        return 0;
      },
    },
    isPackSell:{
      type:Boolean,
      default:() => {
        return false;
      },
    },
    onSelectPharmacy:{
      type:Function,
    },
})

const { medicineId } = toRefs(props);
const listPharmacyGroupRef = ref();
const listPharmacyRef = ref();
const groupId = ref(-2);
const groupName = ref('');
const pharmacyGroupHandler = (name:string,value:Object,eof:Boolean=false) => {
  if (name == 'item') {
  }
}
const pharmacyHandler = (name:string,value:Object,eof:Boolean=false) => {
  if (name == 'item') {
  }
}
const groupOptions = reactive({
  'page_size' : 1000000, //ページング無し
  'medicine_id' : (props.medicineId ? props.medicineId : null),
  'is_group':1,
  'is_pack':(props.type == 'is_pack' ? 1 : null),
  'is_pack_sell':(props.isPackSell ? 1 : null),
});
const listOptions = reactive({
  'page_size' : 30,
  'pharmacy_group_id' : (groupId.value ? groupId.value : null),
  'medicine_id' : (props.medicineId ? props.medicineId : null),
  'is_pack':(props.type == 'is_pack' ? 1 : null),
  'is_pack_sell':(props.isPackSell ? 1 : null),
});
if (props.type == 'is_pack') {
  listOptions.is_pack = 1;
}
const pharmacyGroupReset = () => {
  listPharmacyRef.value.resetItem();
}
const pharmacyReset = () => {
  //
}
const commitPharmacyGroup = (pharmacyGroup) => {
  groupId.value = pharmacyGroup.id;
  groupName.value = pharmacyGroup.medicine_group_name;
  listOptions.pharmacy_group_id = pharmacyGroup.id;
  listPharmacyRef.value.resetItem();
}
const commitPharmacy = (pharmacy) => {
  if (typeof props.onSelectPharmacy !== 'undefined') {
    props.onSelectPharmacy(pharmacy,groupId.value,groupName.value);
  }
}
watch(medicineId,(newValue,oldValue) => {
  groupOptions.medicine_id = newValue;
  listOptions.medicine_id = newValue;
  if (typeof listPharmacyGroupRef.value !== 'undefined') {
    listPharmacyGroupRef.value.resetItem();
  }
  if (typeof listPharmacyRef.value !== 'undefined') {
    listPharmacyRef.value.resetItem();
  }
});
onMounted(() => {
});
</script>

<style scoped>
.address {
  font-size:0.6rem;
}
</style>
<template>
<div class="mb-6 flex flex-row w-full">
  <div class="m-1 pr-1 border-r w-2/5">
    <custom-list
      ref="listPharmacyGroupRef"
      :is-searchable="false"
      :top="false"
      :api-url="apis.pharmacy_relation_medicine_group_list"
      :option-fields="groupOptions"
      height="27vh"
      width="100%"
      :reset="pharmacyGroupReset"
      :handler="pharmacyGroupHandler"
    >
    <template v-slot:item="slotProps">
      <div @click="commitPharmacyGroup(slotProps.item)" class="w-full flex items-center justify-between"><div :class="(groupId == slotProps.item.id ? ' font-bold ' : '')">{{ slotProps.item.medicine_group_name }}</div><div v-show="slotProps.item.old_medicine_count > 0"> <img class="w-6 h-6" src="../../../public/images/icon/icon_old_medicine_alert.png"></div></div>
    </template>
    </custom-list>
  </div>
  <div class="m-1 w-3/5">
    <custom-list
      ref="listPharmacyRef"
      :is-searchable="true"
      place-holder="薬局名を入力してください"
      :top="false"
      height="20vh"
      width="100%"
      :api-url="apis.pharmacy_relation_medicine_group_list"
      :option-fields="listOptions"
      :reset="pharmacyReset"
      :handler="pharmacyHandler"
    >
    <template v-slot:item="slotProps">
      <div @click="commitPharmacy(slotProps.item)" class="w-full flex items-center justify-between">
        <div>
          <div><i v-show="slotProps.item.favorite_level == 1" class="fa-solid fa-star text-amber-400 mr-1"></i>{{ slotProps.item.pharmacy_name }}</div>
          <div class="address">{{ slotProps.item.pharmacy_prefecture + slotProps.item.pharmacy_address + slotProps.item.pharmacy_address_detail }}</div>
        </div>
        <div v-show="slotProps.item.old_medicine_count > 0"> <img class="w-6 h-6" src="../../../public/images/icon/icon_old_medicine_alert.png"></div></div>
    </template>
    </custom-list>
  </div>
</div>
</template>

